<template>
  <div class="w-full h-full">
    <div ref="quill" :options="options" />
  </div>
</template>

<script>
import Quill from "quill"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { imageUploader } from "@/utils/quillEditorImageUploadHelper"

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      // pass any option accepted by quill editor
      type: Object,
      default() {
        return {
          placeholder: "Start writing...",
        }
      },
    },
  },
  data() {
    return {
      quillInstance: null,
      localValue: "",
    }
  },
  computed: {
    getOptions() {
      return {
        ...this.options,
        modules: { ...(this.options && this.options.modules), imageUploader },
        theme: this.options.theme || "snow",
      }
    },
  },
  watch: {
    value(newVal) {
      if (newVal && newVal !== this.localValue) {
        this.localValue = newVal
        this.quillInstance.root.innerHTML = newVal
      }
    },
  },
  beforeDestroy() {
    this.quillInstance.off("text-change", this.emitContent)
  },
  mounted() {
    this.quillInstance = new Quill(this.$refs.quill, this.getOptions)
    this.quillInstance.root.innerHTML = this.value
    this.quillInstance.on("text-change", this.emitContent)
  },
  methods: {
    emitContent() {
      this.localValue = this.quillInstance.root.innerHTML
      this.$emit("input", this.localValue)
    },
  },
}
</script>

<style>
.ql-toolbar {
  position: sticky;
  z-index: 1;
  top: 0;
  background: #fff;
}
</style>
